import { render, staticRenderFns } from "./cadastrarnovo.vue?vue&type=template&id=6f5769c4"
import script from "./cadastrarnovo.vue?vue&type=script&lang=js"
export * from "./cadastrarnovo.vue?vue&type=script&lang=js"
import style0 from "./cadastrarnovo.vue?vue&type=style&index=0&id=6f5769c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports